import { render, staticRenderFns } from "./TextContentComponent.vue?vue&type=template&id=8c428f82&"
import script from "./TextContentComponent.vue?vue&type=script&lang=js&"
export * from "./TextContentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TextContentComponent.vue"
export default component.exports